import { useRef, useState, useEffect } from "react";
import { Paper, ImagePaper } from "./desktopState";


export function ImagePaperArtifact({ paper, updatePosition, tool, onBin }: { paper: ImagePaper; updatePosition?: (paper: Paper, pos: [number, number]) => void; tool: "HAND" | "SCISSORS" | "BIN"; onBin: (paper: Paper) => void; }) {
  const paperRef = useRef<HTMLElement>(null);
  const [grabbing, setGrabbing] = useState(false);

  useEffect(() => {
    if (!updatePosition) return;
    if (!paperRef.current) return;

    paperRef.current.addEventListener("pointerdown", (event) => {
      event.preventDefault();
      setGrabbing(true);
      const paperRect = paperRef.current!.getBoundingClientRect();
      const offsetX = event.clientX - paperRect.left;
      const offsetY = event.clientY - paperRect.top;

      const handlePointerMove = (event: PointerEvent) => {
        event.preventDefault();
        updatePosition(paper, [event.clientX - offsetX, event.clientY - offsetY]);
      };

      const handlePointerUp = (event: PointerEvent) => {
        event.preventDefault();
        setGrabbing(false);
        document.removeEventListener("pointermove", handlePointerMove);
        document.removeEventListener("pointerup", handlePointerUp);
      };

      document.addEventListener("pointermove", handlePointerMove);
      document.addEventListener("pointerup", handlePointerUp);
    });
  }, [updatePosition, paperRef]);
  return <article
    style={{ left: paper.pos[0], top: paper.pos[1] }}
    className={`absolute w-[36rem] shadow ${tool === "HAND" ? (grabbing ? "cursor-grabbing" : "cursor-grab") : "cursor-crosshair"}`}
    ref={paperRef}
    onClick={() => onBin(paper)}
  >
    <img src={paper.imageUrl} alt="Paper" className="w-full h-auto" />
  </article>;
}
